export default function ({
  uploadRowLimit
}: {
  uploadRowLimit: number;
}): JSX.Element {
  return (
    <>
      <p>
        <strong>
          CSV exceeds import limit of {uploadRowLimit.toLocaleString()} rows.
          Please upload a CSV below this row size limit. You may contact
          support@scaletowin.com with any questions.
        </strong>
      </p>
    </>
  );
}
